import { asBondPriceNominal, asCorporateBondId, asYield } from "@goodfill/domain-properties";
import { zRequiredString, zDecimal, zCUSIP } from "@goodfill/domain-properties-zod-validators";
import { applyWithOptionalToNull } from "@goodfill/map";
import { z } from "zod";

export const historicalPriceSchema = z.object({
  bondCusipId: zCUSIP.transform(asCorporateBondId),
  date: zRequiredString(),
  price: zDecimal().transform(asBondPriceNominal),
  yield: zDecimal().transform(asYield),
  total: zDecimal()
    .optional()
    .nullable()
    .transform(applyWithOptionalToNull((a) => a)),
  dealerBuys: zDecimal()
    .optional()
    .nullable()
    .transform(applyWithOptionalToNull((a) => a)),
  dealerSells: zDecimal()
    .optional()
    .nullable()
    .transform(applyWithOptionalToNull((a) => a)),
});

export type HistoricalPrice = z.infer<typeof historicalPriceSchema>;
